import {ModuleWithProviders, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListLinksComponent } from './list-links/list-links.component';
import { EditLinkComponent } from './edit-link/edit-link.component';
import { LinksComponent } from './links.component';
import {MenuService} from '../menu/menu.service';
import {RouterModule} from '@angular/router';
import {linksRoutes} from './links.routes';
import {FormsModule} from '@angular/forms';
import {TagsModule} from '../tags/tags.module';
import {MatTabsModule} from '@angular/material';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {SharedModule} from '../shared/shared.module';
import {DashboardService} from '../dashboard.service';
import {ApiService} from '../api.service';
import {SearchService} from '../search/search.service';
import {SearchResult, SearchResultItem} from '../search/interface.search';

const routing: ModuleWithProviders = RouterModule.forRoot(linksRoutes);
@NgModule({
  imports: [
    CommonModule,
      FormsModule,
      TagsModule,
      MatTabsModule,
      BrowserAnimationsModule,
      SharedModule,
      routing
  ],
  declarations: [ListLinksComponent, EditLinkComponent, LinksComponent]
})
export class LinksModule {
  constructor(
      private menuService: MenuService,
      private dashboardService: DashboardService,
      private apiService: ApiService,
      private searchService: SearchService) {
    this.menuService.addMenuItems(
        [
            {
                name: 'Links',
                path: '/links',
                icon: 'fas fa-link',
                children: [
                    {
                        name: 'list',
                        path: '/links/list'
                    },
                    {
                        name: 'new',
                        path: '/links/new'
                    }
                ]
            }]);
      this.searchService.getSearchTermSubject().subscribe((val) => {
          this.searchService.addSearchResult('links',
              {
                  title: 'Fetching search results for links ...',
                  items: [],
                  footer: '',
                  icon: 'fas fa-link'
              });
          this.apiService.search('links', val).subscribe(
              (value: Array<any>) => {
                  const searchResult: SearchResult = {
                      title: 'Links',
                      items: [],
                      footer: {text: '', buttons: [{link: '/links', linkText: 'All links'}]},
                      icon: 'fas fa-link'
                  };

                  for (const item of value) {
                      const added = new Date(item.added);
                      const label = item.title +
                          ', added on: ' + added.toDateString();
                      const resultItem = {
                          label: label,
                          routerLink: ['/links/edit/', item._id],
                          link: item.url
                      };
                      searchResult.items.push(resultItem);
                  }
                  if (value.length === 0) {
                      searchResult.footer.text = 'No items found';
                  }
                  this.searchService.addSearchResult('links', searchResult);
              });
      });
      this.dashboardService.fetchItems.subscribe((val) => {
          this.dashboardService.addDashboardItem('links', {title: 'Loading Links', items: [], footer: [], icon: 'fas fa-link'});
          this.apiService.getAll('links').subscribe(
              (value: any) => {
                  value.sort((a, b) => {
                      return b['added'] > a['added'] ? 1 : -1;
                  });
                  value.length = Math.min(value.length, 10);
                  const dashboardItems: SearchResult = {
                          title: 'Latest Links',
                          items: [],
                          footer: {text: '', buttons: [
                              {link: '/links', linkText: 'All Links', icon: 'fas fa-link'},
                              {link: '/links/new', linkText: 'New Link', icon: 'fas fa-plus-circle'}
                              ]},
                          icon: 'fas fa-link'
                      };

                  for (let a = 0; a < value.length; a++) {
                      const resultItem = {
                          label:  value[a]['title'],
                          routerLink: ['/links/edit/',  value[a]['_id']],
                          link: value[a]['url']
                      };
                      dashboardItems.items.push(resultItem);
                  }
                  if (value.length === 0) {
                      dashboardItems.footer.text = 'No links added yet';
                  }
                  this.dashboardService.addDashboardItem('links', dashboardItems);
              }
          );
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/links/links.module.ts